<template>
    <div class="tender_data standart_mem">
        
        <standart title="Протокол засідання тендерної комісії з проведення процедури розгляду тендерних пропозицій №" key="tender_addon" v-bind:is_active_result=true v-bind:is_active_problem=true>
            <template v-slot:after_title>
                <b-row class="doc_title">
                    <b-col sm="3">
                        <label for="doc_title">Номер тендеру від Дата тендеру</label>
                    </b-col>
                    <b-col sm="4">
                        <b-form-input class="fs-xl" v-model="form.number_tender"  id="form_tender_number" size="sm" ></b-form-input>
                    </b-col>
                </b-row>
            </template>
        </standart>
        
        
        <b-container fluid>
            <div class="head row-fluid">
                <div class="field" :class="head.class" v-for="head in addon_fields">
                    <div class="title_min">{{head.name}}</div>
                </div>
                <div class="clr"></div>
            </div>
            
            
            <div class="before_change">
                <div class="action_field row" v-for="(row,idx) in form.rows_standart">
                    <div class="field_insert" :class="item.class" v-for="(item,idx2) in addon_fields">
                        <b-form-input
                            v-bind:readonly=form.rows_standart[idx][idx2].is_editor
                            v-if="form.rows_standart[idx][idx2].insert_val !== 'numb'"
                            v-model="form.rows_standart[idx][idx2].value"
                            @click="show_editor('standart',idx,idx2)"
                        >
                        </b-form-input>
                        
                        <div class="np" v-else>{{ idx + 1 }}</div>
                    </div>
                    
                    <div class="remove_row" @click="remove_row('standart',idx)">
                        <i class="fa fa-trash active color-danger-800 cursor-pointer" aria-hidden="true"></i>
                    </div>
                    <div class="clr"></div>
                </div>
                
                <div class="control title_">
                    <button class="btn btn-success " @click="add_row('standart')">Додати</button>
                </div>
            </div>
            
            <div class="pre_title winner">
                Переможець
            </div>
            
            <b-container fluid>
                <div class="after_change">
                    <div class="action_field row" v-for="(row,idx) in form.rows_winner">
                        <div class="np col-1" >{{ idx + 1 }}</div>
                        
                        <div class="field_insert" :class="item.class" v-for="(item,idx2) in winner_fields">
                            <b-form-input
                                :class="filed_class(form.rows_winner[idx][idx2])"
                                v-bind:readonly="form.rows_winner[idx][idx2].is_editor"
                                v-bind:placeholder=form.rows_winner[idx][idx2].text
                                v-model="form.rows_winner[idx][idx2].value"
                                @click="show_editor('winner',idx,idx2)"
                            >
                            </b-form-input>
                        </div>
                        
                        <div class="remove_row" @click="remove_row('winner',idx)">
                            <i class="fa fa-trash active color-danger-800 cursor-pointer" aria-hidden="true"></i>
                        </div>
                        <div class="clr"></div>
                    </div>
                    <div class="control title_">
                        <button class="btn btn-success " @click="add_row('winner')" >Додати</button>
                    </div>
                </div>
            </b-container>
        
        </b-container>
    
    </div>
</template>

<script>
import standart from '../standart.vue'
import { VueEditor } from "vue2-editor";

import {createHelpers} from 'vuex-map-fields';
const {mapFields} = createHelpers({
    getterType: 'memorandum_create/getMemCreateField',
    mutationType: 'memorandum_create/updateMemCreateField',
});


export default {
    name: "tender",
    components: {
        standart,
        VueEditor
    },
    
    created() {
        EventBus.$on('finish_edit', e => {
            this.upd_from_editor(e.uniq, e.text)
        });
    },
    
    beforeDestroy() {
        EventBus.$off('finish_edit',this.upd_from_editor);
    },
    
    data() {
        return {
            editor_rules :[
                ["bold", "italic", "underline","link"],
                [{ align: "center" }, { align: "right" },{ align: "justify" }],
                [{ list: "ordered" }, { list: "bullet" },{ list: "check" }],
            ],
            
            form : {
                number_tender : '',
                rows_standart: [],
                rows_winner : [],
            },
            
            
            winner_fields : [
                {
                    name : 'counterparty',
                    text : 'Переможець',
                    value : '',
                    class : 'col-2',
                    is_editor : true,
                },
                {
                    name: 'payment',
                    text: 'Обгрунтування',
                    value: '',
                    class: 'col-3',
                    is_editor : true,
                },
            ]
        }
    },
    
    mounted() {
    
    },
    
    methods: {
        upd_from_editor : function (uniq,value) {
            if(uniq != undefined) {
                try {
                    let arr_obj = uniq.split('_');
                    if (arr_obj[0] === 'standart') {
                        this.form.rows_standart[arr_obj[1]][arr_obj[2]].value = value;
                        
                    }
                    if (arr_obj[0] === 'winner') {
                        this.form.rows_winner[arr_obj[1]][arr_obj[2]].value = value;
                        
                    }
                }
                catch (e) {
                    EventBus.$emit('show_toast', {err:e.message ,type:"danger",title:e.name})
                }
            }
            
        },
        
        
        filed_class : function (item) {
            if(item.is_editor) {
                return 'editor_on';
            }
        },
        
        show_editor : function (type,idx,idx2) {
            try {
                if (type === 'standart') {
                    if (this.form.rows_standart[idx][idx2].is_editor) {
                        EventBus.$emit('load_editor', {
                            'message': this.form.rows_standart[idx][idx2].value,
                            'uniq': 'standart_' + idx + '_' + idx2
                        });
                    }
                }
                
                if (type === 'winner') {
                    if (this.form.rows_winner[idx][idx2].is_editor) {
                        EventBus.$emit('load_editor', {
                            'message': this.form.rows_winner[idx][idx2].value,
                            'uniq': 'winner_' + idx + '_' + idx2
                        });
                    }
                }
                
            }
            catch (e) {
                EventBus.$emit('show_toast', {err:e.message ,type:"danger",title:e.name})
            }
        },
        
        add_row : function (type) {
            
            if(type === 'standart') {
                let arr_push = JSON.parse(JSON.stringify(this.addon_fields));
                this.form.rows_standart.push(arr_push);
            }
            
            if(type === 'winner') {
                let arr = JSON.parse(JSON.stringify(this.winner_fields));
                this.form.rows_winner.push(arr);
            }
            
        },
        
        remove_row : function (type,idx) {
            if(type === 'standart') {
                this.form.rows_standart.splice(idx,1);
            }
            if(type === 'winner') {
                this.form.rows_winner.splice(idx,1);
            }
        },
        
    },
    
    
    computed: {
        ...mapFields([
            'active_memorandum'
        ]),
        
        
        addon_fields() {
            return this.active_memorandum.addon_data;
        },
        
        
        return_data : function () {
            return this.form;
        }
        
    },
 
    
    
}

</script>

<style scoped>

</style>
